package com.kinoshazam.uiKit.button

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.theme.UiKitTheme

@Composable
fun UiKitButton(
    state: UiKitButtonState,
    onClick: (() -> Unit)? = null,
    modifier: Modifier = Modifier,
) {
    Button(
        modifier = modifier,
        contentPadding = state.defaults.contentPadding,
        colors = ButtonDefaults.buttonColors(
            containerColor = state.backgroundColor ?: Color.Transparent,
            disabledContainerColor = state.backgroundColor ?: Color.Transparent,
        ),
        shape = state.shape,
        onClick = onClick ?: {},
        enabled = onClick != null,
    ) {
        if (state.contentState == ButtonContentState.LOADING) {
            CircularProgressIndicator(
                modifier = Modifier.size(24.dp),
                color = UiKitTheme.colors.color_7,
                strokeWidth = 2.dp,
            )
        } else {
            state.title?.let {
                TextLabel(state = it)

                Spacer(modifier = Modifier.width(6.dp))
            }

            state.icon?.let { icon ->
                Image(
                    painter = icon,
                    colorFilter = state.iconColor?.let { ColorFilter.tint(it) } ?: ColorFilter.tint(
                        UiKitTheme.colors.color_7
                    ),
                    contentDescription = null,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.padding()
                )
            }
        }
    }
}
